module.exports = __webpack_public_path__ + "media/images/lb/092-c4c3159c154958d97ba9a3ee9551cd3d.svg";